import { useAppDispatch } from 'hooks/redux';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';
import { routes } from 'shared/common/routes';
import { actions, selectors } from 'store/ducks';
import styled from 'styled-components';

import { containImageStyle } from '../../../utils/containImageStyle';

const StyledWrapper = styled.div({
  boxSizing: 'border-box',
  width: 250,
  height: 250,
  paddingTop: 27,
  paddingLeft: 15,
  paddingRight: 15,
  borderRadius: '50%',
  backgroundImage: 'linear-gradient(to right,#862fff 10%,#9c3efe 40%,#AE4CFE 90%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const StyledIcon = styled.div({
  width: 54,
  height: 54,
  marginBottom: 11,
  ...containImageStyle('/landing/banners/popular-rocket.png'),
});

const StyledTitle = styled.div({
  opacity: 0.9,

  fontSize: 17,
  fontWeight: 'bold',
  lineHeight: 1.18,
  textAlign: 'center',
  color: '#ffffff',
  marginBottom: 6,
});

const StyledDescription = styled.div({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.46,
  textAlign: 'center',
  color: '#ffffff',
});

const StyledButton = styled.button({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.46,
  color: '#ffffff',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  textDecoration: 'underline',
});

export const Icon: FC = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const user = useSelector(selectors.profile.selectUser);

  const register = () => {
    if (user.id) {
      router.push({ pathname: routes.profile, query: { activeTab: 'expertProfile' } });
    } else {
      dispatch(actions.app.showAuthModal());
    }
  };

  return (
    <StyledWrapper>
      <StyledIcon />

      {/* <StyledTitle>
        <div>Запуск сервиса —</div>

        <div>в мае!</div>
      </StyledTitle> */}

      <StyledDescription>
        <StyledButton onClick={register}>Зарегистрируйтесь</StyledButton>
        сейчас и станьте одним из первых экспертов Consulty.
      </StyledDescription>
    </StyledWrapper>
  );
};
